export default function (err, res) {
  return err || !res ||
    (res && res.body && res.body.errors) ||
    (res && res.error);
}
